import type { Pessoa } from '@sheafyield/dominio';
import { useRef, useState } from 'react';
import { Botao } from '../ds/Botao.js';
import { CampoLongo } from '../ds/CampoLongo.js';
import { Folha } from '../ds/Folha.js';
import {
  lerRascunhoDaFicha,
  gravarRascunhoDaFicha,
  limparRascunhoDaFicha,
} from './rascunhoDaFicha.js';

export function FolhaNota({
  pessoa,
  aoSalvar,
  aoFechar,
}: {
  pessoa: Pessoa;
  aoSalvar: (nota: string) => Promise<void>;
  aoFechar: () => void;
}) {
  const [nota, setNota] = useState(() => {
    const r = lerRascunhoDaFicha(pessoa, 'nota');
    return r?.tipo === 'nota' ? r.nota : pessoa.nota;
  });
  const [erro, setErro] = useState<string | null>(null);
  const [salvando, setSalvando] = useState(false);
  const emCurso = useRef(false);
  const campo = useRef<HTMLFormElement>(null);
  async function salvar() {
    if (emCurso.current) return;
    emCurso.current = true;
    setSalvando(true);
    setErro(null);
    try {
      await aoSalvar(nota);
      limparRascunhoDaFicha(pessoa, 'nota');
    } catch (causa) {
      setErro(
        causa instanceof Error
          ? causa.message
          : 'Não deu para salvar a nota. Tente novamente.',
      );
    } finally {
      emCurso.current = false;
      setSalvando(false);
    }
  }
  return (
    <Folha
      aberta
      titulo="Adicionar nota"
      aoFechar={() => {
        if (emCurso.current) return false;
        return aoFechar();
      }}
      focoInicial={campo}
    >
      <form
        ref={campo}
        tabIndex={-1}
        className="ficha__formulario"
        onSubmit={(evento) => {
          evento.preventDefault();
          void salvar();
        }}
      >
        <p>{pessoa.nome.trim() || pessoa.endereco || 'Pessoa sem nome'}</p>
        <CampoLongo
          rotulo="Nota"
          value={nota}
          onChange={(evento) => {
            const nota = evento.target.value;
            setNota(nota);
            gravarRascunhoDaFicha(pessoa, { tipo: 'nota', nota });
          }}
          rows={5}
          dica="Use também o ditado do teclado do iPhone."
          disabled={salvando}
        />
        {erro === null ? null : <p role="alert">{erro}</p>}
        <Botao type="submit" largura="cheia" disabled={salvando}>
          {salvando ? 'Salvando…' : 'Salvar nota'}
        </Botao>
      </form>
    </Folha>
  );
}
